import React from "react";
import LabReport1 from './LabReport.css';

export default function LabReport() {
  return (
    <div className="report-wrapper">
      <header className="page-header">
        <p>Swagatam Hospital & Research Centre - Patient Report</p>
      </header>

      <div className="lab-report">
        <div className="header">
          <div className="header-left">
            <h1>SWAGATAM HOSPITAL & RESEARCH CENTRE</h1>
            <p>Registration No. – 1830300453</p>
            <p>B.H. Road, Barpeta Town (Opposite to Magistrate Colony), Assam - 781314</p>
            <p>Phone: +91 8099274142 | Email: swagatamhospital.bpt@gmail.com</p>
          </div>
          <div className="header-right">
            <img src="/logo.png" alt="Hospital Logo" />
          </div>
        </div>

        <div className="info-grid">
          <div><strong>UHID:</strong> MAN80302</div>
          <div><strong>Registration ID:</strong> 51629</div>
          <div><strong>Patient Name:</strong> Mrs. MANJUWARA KHATUN</div>
          <div><strong>Gender:</strong> Female / <strong>Age:</strong> 36 Yrs</div>
          <div><strong>Collected At:</strong> SHRC</div>
          <div><strong>Referred By:</strong> Dr. DIN DAYAL SINGH</div>
          <div><strong>Sample Collected By:</strong> ARZINA</div>
          <div><strong>Sample Date:</strong> 05-06-2025 10:49</div>
          <div><strong>Reported On:</strong> 05-06-2025</div>
        </div>

        <section className="section">
          <h2>SEROLOGY</h2>
          <table>
            <thead>
              <tr>
                <th>TEST NAME</th>
                <th>RESULT</th>
                <th>UNITS</th>
                <th>NORMAL RANGES</th>
                <th>METHOD</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Anti HCV</td>
                <td>NON REACTIVE</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>HIV I & II</td>
                <td>NON REACTIVE</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </section>

        <section className="section">
          <h2>CLINICAL BIOCHEMISTRY</h2>
          <table>
            <tbody>
              <tr>
                <td>HBsAg</td>
                <td>NON REACTIVE</td>
                <td colSpan={3}></td>
              </tr>
            </tbody>
          </table>
        </section>

        <section className="section">
          <h2>HORMONES</h2>
          <table>
            <thead>
              <tr>
                <th>TEST NAME</th>
                <th>RESULT</th>
                <th>UNITS</th>
                <th>NORMAL RANGES</th>
                <th>METHOD</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>TSH</td>
                <td>1.83</td>
                <td>mIU/L</td>
                <td>0.25 - 5.0</td>
                <td>FIA</td>
              </tr>
            </tbody>
          </table>
        </section>

        <p className="note">
          Note: This is an electronic authentication report. Assay results should be correlated clinically with other findings and the patient status.
        </p>

        <div className="signatures">
          <div className="lab-tech">Lab Technician</div>
          <div className="doctor">
            <p>Dr. A . Bharali (MD)</p>
            <p>Consultant Pathologist</p>
          </div>
        </div>

        <p className="footer-note">
          N.B.: This report is not meant for medico legal purpose. Please correlate results with clinical findings. In case of any visible print/script error, inform hospital.
        </p>
      </div>

      <footer className="page-footer">
        <p>Generated by Swagatam Hospital & Research Centre | Page 1</p>
      </footer>
    </div>
  );
}
